module.exports = __webpack_public_path__ + "img/section-5-2.9bb83dc.webp";